module.exports = __webpack_public_path__ + "static/media/image_icon.b4290445.svg";